function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { captureWebVitals } from '../webVitals';
const STYLES = {
    background: 'green',
    color: 'white',
    display: 'block'
};
const STYLES_STRING = Object.keys(STYLES).map((key)=>`${key}: ${STYLES[key]}; `).join('');
export class ConsoleProvider {
    ready() {
        var _this = this;
        return _async_to_generator(function*() {
            return !!_this.logger;
        })();
    }
    trackPage(page) {
        var _this = this;
        return _async_to_generator(function*() {
            _this.logger.info('%c [Analytics] Page tracked', STYLES_STRING);
            _this.logger.table(page);
        })();
    }
    trackEvent(event) {
        var _this = this;
        return _async_to_generator(function*() {
            _this.logger.info('%c [Analytics] Event tracked', STYLES_STRING);
            _this.logger.table(event);
        })();
    }
    trackVitals(vitals) {
        var _this = this;
        return _async_to_generator(function*() {
            const metrics = yield captureWebVitals(vitals);
            _this.logger.info('%c [Analytics] Vitals tracked', STYLES_STRING);
            _this.logger.table(metrics);
        })();
    }
    setExperimentTreatment(treatment) {
        var _this = this;
        return _async_to_generator(function*() {
            _this.logger.info('%c [Analytics] Experiment treatment set', STYLES_STRING);
            _this.logger.table(treatment);
        })();
    }
    constructor(logger){
        _define_property(this, "logger", void 0);
        this.logger = logger;
    }
}

//# sourceMappingURL=Console.js.map